import VueRouter from 'vue-router';
import Dashboard from './views/pages/Dashboard.vue';
import FormPage from "./views/pages/FormPage.vue";
import FormPageFull from "./views/pages/FormPageFull.vue";

Vue.use(VueRouter);

let routes = [
    {
        path: '/',
        component: Dashboard,
        meta: {
            title: "dashboard",
        },
        alias: '/home',
        name: 'dashboard',
        children: [
            {
                path: 'dashboard/:bundle/:definition/:objectId/:relationString?',
                name: 'dashboard-form',
                components:{
                    childview: {
                        template: '<cms-form v-on="$listeners"/>',
                    }
                },
            }
        ]
    },
    {
        path: '/form/:bundle/:definition/:objectId?/:relationString?',
        name: 'formPage',
        component: FormPage,
        meta: {
            title: "Form"
        },
    },
    {
        path: '/full-form/:bundle/:definition/:objectId?/:relationString?',
        component: FormPageFull,
        name: 'full-form',
        meta: {
            title: 'Full Screen Form',
        }
    }
];


routes = Vue.cmsRouter.setRoutes(routes);

// Change home dashboard
const homeRouteKey = routes.findIndex(route => route.path === '/');
routes[homeRouteKey] = {
    path: '/',
    component: Dashboard,
    meta: {
        title: "dashboard",
    },
    alias: '/home'
}

const router = new VueRouter({
    routes
});


Vue.cmsRouter.setActiveRouter(router);

export default router;
